export default __webpack_public_path__ + "static/national-yards-mobile-523655313b5e424d459825d5dfd8b7d4.svg";